import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QuizQuestionsState } from '../reducers/quiz-questions.reducer';
import { QUIZ_QUESTIONS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<QuizQuestionsState>(QUIZ_QUESTIONS_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: QuizQuestionsState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: QuizQuestionsState) => state.loading);
export const selectQuizQuestions = createSelector(selectState, (state: QuizQuestionsState) => state.quizQuestions);
export const selectTotal = createSelector(selectState, (state: QuizQuestionsState) => state.total);
export const selectPage = createSelector(selectState, (state: QuizQuestionsState) => state.page);
export const selectLimit = createSelector(selectState, (state: QuizQuestionsState) => state.limit);
export const selectLastParams = createSelector(selectState, (state: QuizQuestionsState) => state.lastParams);
